/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { Table } from '@tanstack/react-table';
import {
  getTableColumnPinLeftVariable,
  getTableColumnPinRightVariable,
  getTableColumnSizeVariable,
  getTableHeaderSizeVariable,
} from '../utils';
import { getOffset } from '../utils/utils';

interface UseColumnResizeVariablesProps<T> {
  table: Table<T>;
}

export const useColumnResizeVariables = <T>({
  table,
}: UseColumnResizeVariablesProps<T>) => {
  const columnPinningVars = useMemo(() => {
    const headers = table.getFlatHeaders();
    const columnVariables: Record<string, number | string> = {};
    const leftLeafColumns = table.getLeftLeafColumns();
    const rightLeafColumns = table.getRightLeafColumns();

    headers.forEach(header => {
      const column = header.column;

      const pinPosition = column.getIsPinned();
      if (pinPosition === 'left') {
        columnVariables[getTableColumnPinLeftVariable(column.id)] = getOffset({
          column,
          leftLeafColumns,
          rightLeafColumns,
          side: 'left',
        });
      } else if (pinPosition === 'right') {
        columnVariables[getTableColumnPinRightVariable(column.id)] = getOffset({
          column,
          leftLeafColumns,
          rightLeafColumns,
          side: 'right',
        });
      }
    });

    return columnVariables;
  }, [
    table.getState().columnPinning,
    table.getState().columnSizingInfo,
    table.getState().columnSizing,
    table,
  ]);

  const columnSizeVars = useMemo(() => {
    const headers = table.getFlatHeaders();
    const columnVariables: Record<string, number | string> = {};
    // TODO: add proper shadow and resize indicator
    // const currentResizingColumn =
    //   table.getState().columnSizingInfo.isResizingColumn;

    headers.forEach(header => {
      const column = header.column;
      columnVariables[getTableHeaderSizeVariable(header.id)] = header.getSize();
      columnVariables[getTableColumnSizeVariable(column.id)] = column.getSize();

      // if (
      //   typeof currentResizingColumn !== 'string' ||
      //   currentResizingColumn !== column.id
      // )
      //   return (columnVariables[getTableColumnBorderVariable(column.id)] =
      //     'inherit');

      // columnVariables[getTableColumnBorderVariable(column.id)] =
      //   '1px solid #2FCFD3';
    });

    return columnVariables;
  }, [table.getState().columnSizingInfo, table.getState().columnSizing, table]);

  return { ...columnSizeVars, ...columnPinningVars };
};
